import { Navigate } from "react-router-dom";
import { useUser } from "@clerk/react";
import { AppShell } from "./Dashboard";
import { ManagerSidebar } from "@/components/nav_components/manager-sidebar";

/**
 * Staff-only /manager area (Clerk publicMetadata uplodio_member): the
 * dashboard's frame with its own sidebar. Everyone else lands on /dashboard;
 * the pages and their API routes re-check the flag.
 */
export default function Manager() {
  const { user, isLoaded } = useUser();
  const isStaff = Boolean(
    (user?.publicMetadata as Record<string, unknown> | undefined)?.uplodio_member
  );

  if (!isLoaded) return null;
  if (!isStaff) return <Navigate to="/dashboard" replace />;

  return <AppShell sidebar={<ManagerSidebar />} />;
}
